import * as React from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import AddInventory from './components/inventory/AddInventory';
import Inventory from './components/inventory/Inventory';
import Solr from './components/solr/Solr';
import ExportPrices from './components/export/ExportPrices';
import RebuildShortCodes from './components/utility/RebuildShortCodes';
import UpdateInventoryPrices from './components/utility/UpdateInventoryPrices';
import DownloadPartnerLogFile from './components/utility/DownloadPartnerLogFile';
import DownloadAllPartnersInventoryFile from './components/utility/DownloadAllPartnersInventoryFile';
import ProductBuilder from './components/editors/ProductBuilder';
import { AuthenticationContext } from './components/context/AuthenticationContext';
import { ApplicationState } from './store';
import * as AuthorizationStore from './store/Authorization';
import 'react-toastify/dist/ReactToastify.css';
import '@progress/kendo-theme-default/dist/all.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './custom.css'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ProductSearchPage from './pages/ProductSearchPage';
import ProductAttributesPage from './pages/ProductAttributesPage';
import CartPage from './pages/CartPage';
import SearchCartPage from './pages/Cart/SearchCartPage';
import SearchOrderPage from './pages/Order/SearchOrderPage';
import CheckoutPage from './pages/Checkout/CheckoutPage';
import Auth from './pages/Auth';
import AzureADAuthenticate from './pages/AzureADAuthenticate';
import { ToastContainer } from 'react-toastify';
import { PrivateRoute } from './components/PrivateRoute';
import withClearCache from "./ClearCache";
import TagManager from 'react-gtm-module';

interface Props {
    children?: React.ReactNode;
    authorization: AuthorizationStore.IState;
    authorizationActions: typeof AuthorizationStore.actionCreators;
}

const tagManagerArgs = {
    gtmId: 'GTM-KM735KW'
}

TagManager.initialize(tagManagerArgs);

class App extends React.Component<Props, {}>{

    componentDidMount() {
        this.props.authorizationActions.getAzureConfigurations();
        this.props.authorizationActions.loadAllUsers();
        this.props.authorizationActions.getCurrentAzureTokenAndUser();
    }

    render() {
        return <AuthenticationContext.Provider value={{ currentUser: this.props.authorization.currentUser, authorizationActions: this.props.authorizationActions }}>
            <Layout>
                <PrivateRoute exact path='/' component={ProductSearchPage} />
                <Route path='/login' component={AzureADAuthenticate} />
                <Route path='/auth' component={Auth} />
                <PrivateRoute path='/cart' component={CartPage} />
                <PrivateRoute path='/cart-search' component={SearchCartPage} />
                <PrivateRoute path='/order-search' component={SearchOrderPage} />
                <PrivateRoute path='/checkout' component={CheckoutPage} />
                <PrivateRoute path='/solr' component={Solr} />
                <PrivateRoute path='/export/prices' component={ExportPrices} />
                <PrivateRoute path='/rebuildshortcodes' component={RebuildShortCodes} /> 
                <PrivateRoute path='/updateinventoryprices' component={UpdateInventoryPrices} />
                <PrivateRoute path='/admin/product-builder' component={ProductBuilder} />
                <PrivateRoute path='/admin/product-attributes' component={ProductAttributesPage} />
                <PrivateRoute path='/admin/inventory-export' component={DownloadAllPartnersInventoryFile} /> 
                <PrivateRoute path='/admin/log' component={DownloadPartnerLogFile} />
            </Layout>
            <ToastContainer position='top-right' />
        </AuthenticationContext.Provider>
    }
}

const ClearCacheComponent = withClearCache(App);

export default connect(
    (state: ApplicationState) => ({
        authorization: state.authorization
    }), // Selects which state properties are merged into the component's props
    (dispatch, getState) => ({
        authorizationActions: bindActionCreators(AuthorizationStore.actionCreators, dispatch)
    })

)(ClearCacheComponent as any)